import { render, staticRenderFns } from "./otherSideIndex.vue?vue&type=template&id=8a9f4b44&scoped=true"
import script from "./otherSideIndex.vue?vue&type=script&lang=js"
export * from "./otherSideIndex.vue?vue&type=script&lang=js"
import style0 from "./otherSideIndex.vue?vue&type=style&index=0&id=8a9f4b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9f4b44",
  null
  
)

export default component.exports